import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "card card-custom gutter-b example example-compact w-100" }
const _hoisted_3 = { class: "card-header d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "mt-4" }, "Iniciar Laudo", -1)
const _hoisted_5 = { class: "text-muted font-weight-bold font-size-sm my-1" }
const _hoisted_6 = { class: "text-muted mb-4 font-weight-bold font-size-sm" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cliente: ")
const _hoisted_8 = { class: "text-dark font-weight-bold" }
const _hoisted_9 = { class: "container-fluid mb-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Foto principal", -1)
const _hoisted_13 = { class: "col-lg-8" }
const _hoisted_14 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/carros.jpg)"}
}
const _hoisted_15 = {
  class: "\n                    btn btn-icon btn-circle btn-active-color-primary\n                    w-25px\n                    h-25px\n                    bg-white\n                    shadow\n                  ",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "form-text" }, "Aceito somente arquivos de imagem", -1)
const _hoisted_20 = { class: "col-md-8" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Parecer final", -1)
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = {
  class: "accordion",
  id: "accordionEvidencias"
}
const _hoisted_26 = { class: "accordion-item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h2", { class: "accordion-header" }, [
  /*#__PURE__*/_createVNode("button", {
    class: "accordion-button bg-white text-dark fs-1 text-center",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#documento",
    "aria-expanded": "true",
    "aria-controls": "documento"
  }, " Documentos ")
], -1)
const _hoisted_28 = {
  id: "documento",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "documento",
  "data-bs-parent": "#accordionEvidencias"
}
const _hoisted_29 = { class: "card-body mb-10" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = /*#__PURE__*/_createVNode("h4", null, "Documentos já adicionadas", -1)
const _hoisted_32 = { class: "d-flex flex-nowrap overflow-auto align-items-start my-3" }
const _hoisted_33 = { class: "overlay-wrapper" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download fs-4 me-2" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode()
const _hoisted_36 = { class: "fs-9" }
const _hoisted_37 = { class: "overlay-layer bg-dark bg-opacity-10" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file fs-3" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, "Adicionar documentos", -1)
const _hoisted_41 = {
  key: 0,
  class: "border p-2 mt-3"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("h4", null, "Documentos para adicionar:", -1)
const _hoisted_43 = { class: "\n                      d-flex\n                      flex-nowrap\n                      overflow-auto\n                      align-items-start\n                      mb-3\n                    " }
const _hoisted_44 = { class: "progress mt-3 mb-3" }
const _hoisted_45 = {
  class: "progress-bar progress-bar-striped",
  role: "progressbar",
  style: {"width":"0%"},
  "aria-valuenow": "100",
  "aria-valuemin": "0",
  "aria-valuemax": "100",
  ref: "progressBarDocumento"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("span", null, "Enviar documentos", -1)
const _hoisted_47 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_48 = { class: "card-body mb-10" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = /*#__PURE__*/_createVNode("h4", null, "Fotos já adicionadas", -1)
const _hoisted_51 = { class: "\n                      d-flex\n                      flex-nowrap\n                      overflow-auto\n                      align-items-start\n                      mb-3\n                    " }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fa fa-camera fs-3" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("span", null, "Adicionar imagens", -1)
const _hoisted_54 = {
  key: 0,
  class: "border p-2 mt-3"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("h4", null, "Imagens para adicionar:", -1)
const _hoisted_56 = { class: "\n                        d-flex\n                        flex-nowrap\n                        overflow-auto\n                        align-items-start\n                        mb-3\n                      " }
const _hoisted_57 = { class: "progress mt-3 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cadastro.marca) + " - " + _toDisplayString(_ctx.cadastro.modelo) + " | " + _toDisplayString(_ctx.cadastro.placa), 1),
        _createVNode("span", _hoisted_6, [
          _hoisted_7,
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.cadastro.nome), 1)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", {
                  class: "image-input-wrapper w-100px h-100px",
                  style: `background-image: url('${
                    _ctx.cadastro.imagem ? _ctx.cadastro.imagem : _ctx.previewImage
                  }')`
                }, null, 4),
                _createVNode("label", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("input", {
                    type: "file",
                    name: "avatar",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFotoPrincipalAdd && _ctx.onFotoPrincipalAdd(...args))),
                    accept: ".png, .jpg, .jpeg",
                    ref: "imagem"
                  }, null, 544),
                  _hoisted_17
                ]),
                _createVNode("span", {
                  class: "\n                    btn btn-icon btn-circle btn-active-color-primary\n                    w-25px\n                    h-25px\n                    bg-white\n                    shadow\n                  ",
                  "data-kt-image-input-action": "remove",
                  "data-bs-toggle": "tooltip",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeImage())),
                  title: "Remove avatar"
                }, [
                  _hoisted_18
                ])
              ]),
              _hoisted_19
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _withDirectives(_createVNode("textarea", {
                class: "w-100",
                rows: "5",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cadastro.parecerFinal = $event))
              }, null, 512), [
                [_vModelText, _ctx.cadastro.parecerFinal]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("button", {
              class: "btn btn-success",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.salvarParecerFinaleFoto && _ctx.salvarParecerFinaleFoto(...args)))
            }, " Salvar alterações ")
          ])
        ])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode("div", _hoisted_32, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentos, (documento, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "overlay"
                    }, [
                      _createVNode("div", _hoisted_33, [
                        _createVNode("a", {
                          href: documento.url,
                          target: "_blank",
                          class: "btn btn-sm btn-secondary me-1"
                        }, [
                          _hoisted_34,
                          _hoisted_35,
                          _createVNode("span", _hoisted_36, _toDisplayString(documento.nome), 1)
                        ], 8, ["href"])
                      ]),
                      _createVNode("div", _hoisted_37, [
                        _createVNode("button", {
                          onClick: ($event: any) => (_ctx.removeDocumento(documento.id, index)),
                          class: "btn btn-sm btn-danger"
                        }, [
                          _hoisted_38
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("button", {
                  class: "btn btn-light-primary d-flex align-items-center",
                  onClick: _cache[5] || (_cache[5] = 
                    () => {
                      _ctx.inputDocumento.click();
                    }
                  )
                }, [
                  _hoisted_39,
                  _hoisted_40
                ]),
                _createVNode("input", {
                  type: "file",
                  multiple: "multiple",
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDocumentoAdd && _ctx.onDocumentoAdd(...args))),
                  class: "form-control-file d-none",
                  id: "my-file",
                  ref: "inputDocumento"
                }, null, 544),
                (_ctx.previewDocsList.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode("div", _hoisted_43, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewDocsList, (item, j) => {
                            return (_openBlock(), _createBlock("li", { key: j }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_44, [
                _createVNode("div", _hoisted_45, null, 512)
              ]),
              _createVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.enviarDocumentos && _ctx.enviarDocumentos(...args))),
                class: "btn btn-success mt-5"
              }, [
                _hoisted_46
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.perguntas, (categoria, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "accordion-item"
          }, [
            _createVNode("h2", _hoisted_47, [
              _createVNode("button", {
                class: "accordion-button bg-white text-dark fs-1 text-center",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": '#' + categoria.value,
                "aria-expanded": "true",
                "aria-controls": categoria.value
              }, _toDisplayString(categoria.text), 9, ["data-bs-target", "aria-controls"])
            ]),
            _createVNode("div", {
              id: categoria.value,
              class: ["accordion-collapse collapse", { show: i === 0 }],
              "aria-labelledby": "headingOne",
              "data-bs-parent": "#accordionEvidencias"
            }, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode("div", _hoisted_51, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoriaFilter(
                        categoria.value
                      ), (evidencia, index) => {
                      return (_openBlock(), _createBlock("img", {
                        key: index,
                        src: evidencia.url,
                        class: "img-thumbnail mw-100px"
                      }, null, 8, ["src"]))
                    }), 128))
                  ]),
                  _createVNode("button", {
                    class: "btn btn-light-primary d-flex align-items-center",
                    onClick: 
                      () => {
                        _ctx.inputs[i].click();
                      }
                    
                  }, [
                    _hoisted_52,
                    _hoisted_53
                  ], 8, ["onClick"]),
                  _createVNode("input", {
                    type: "file",
                    multiple: "multiple",
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFileAdd && _ctx.onFileAdd(...args))),
                    class: "form-control-file d-none",
                    id: "my-file",
                    ref: 
                      (el) => {
                        _ctx.inputs[i] = el;
                      }
                    
                  }, null, 544),
                  (_ctx.previewList.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_54, [
                        _hoisted_55,
                        _createVNode("div", _hoisted_56, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewList, (item, j) => {
                            return (_openBlock(), _createBlock("img", {
                              key: j,
                              src: item,
                              class: "img-thumbnail mw-100px"
                            }, null, 8, ["src"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", {
                    class: "progress-bar progress-bar-striped",
                    role: "progressbar",
                    style: {"width":"0%"},
                    "aria-valuenow": "100",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    ref: 
                      (el) => {
                        _ctx.progressBars[i] = el;
                      }
                    
                  }, null, 512)
                ]),
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.enviar(categoria.value, i)),
                  class: "btn btn-success mt-5"
                }, [
                  _createVNode("span", null, "Enviar respostas " + _toDisplayString(categoria.text), 1)
                ], 8, ["onClick"])
              ])
            ], 10, ["id"])
          ]))
        }), 128))
      ])
    ])
  ]))
}